import React, { useState } from "react";
import { Tooltip } from "@mui/material";
import { Card, CardBody } from "reactstrap";
import { MdOutlineSimCardDownload } from "react-icons/md";

import {
  successToast,
  failureToast,
} from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import { AGridColDef } from "../../../common/data-grid/ADataGridColDef";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { isFilterApplied } from "../../constant/batch-search";

import {
  DISABLE_SCAN_MSG,
  SCAN_BTN_STYLES,
  saveRfidPsid,
  LastUpdatedDetails,
  SEARCH_BY,
  downloadConsentCsv,
  ADMIN_ROLE_TYPES,
} from "./helper";
import ScanRfid from "./ScanRfid";

const MaterialDistributionTable = ({
  rowData,
  pageSize,
  setPageSize,
  totalRows,
  currentPage,
  setCurrentPage,
  isLoading,
  setIsLoading,
  searchStudentsForMaterials,
  filters,
  setFilters,
  scannedRows,
  selectionModel,
  setSelectionModel,
  permissions,
}) => {
  const [isScanDialogOpen, setIsScanDialogOpen] = useState(false);
  const [userSearchInput, setUserSearchInput] = useState("");
  const [selected, setSelected] = useState("psid");

  const columns = [
    new AGridColDef("psid", "PSID")
      .columnAlign("center")
      .setFlex(0.3)
      .setMinWidth(150)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className="ellipsis-text-container">{params?.value}</div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      ),

    new AGridColDef("studentName", "NAME")
      .columnAlign("center")
      .setFlex(0.3)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className="ellipsis-text-container">{params?.value}</div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      ),

    new AGridColDef("businessAreaDispVal", "BU CODE")
      .columnAlign("center")
      .setFlex(0.3)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className="ellipsis-text-container">{params?.value}</div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      ),

    new AGridColDef("applicationId", "APP. ID")
      .columnAlign("center")
      .setFlex(0.3)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className="ellipsis-text-container">{params?.value}</div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      ),

    new AGridColDef("courseId", "COURSE ID")
      .columnAlign("center")
      .setFlex(0.3)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className="ellipsis-text-container">{params?.value}</div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      ),

    new AGridColDef("materialId", "MATERIAL ID")
      .columnAlign("center")
      .setFlex(0.4)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.row.materialDesc}>
            <div className="ellipsis-text-container">{params?.value}</div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      ),

    new AGridColDef("termDispVal", "TERM")
      .columnAlign("center")
      .setFlex(0.2)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className="ellipsis-text-container">{params?.value}</div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      ),

    new AGridColDef("programAction", "PROG. ACTION")
      .columnAlign("center")
      .setFlex(0.3)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className="ellipsis-text-container">{params?.value}</div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      ),

    new AGridColDef("consentDate", "CONSENT STATUS")
      .columnAlign("center")
      .setMinWidth(230)
      .setFlex(0.3)
      .renderCellComponent((params) => {
        return !params?.row.isEligibleForScan ? (
          <Tooltip title={`RFID: ${params.row?.rfid}`}>
            <div className="ellipsis-text-container">
              {LastUpdatedDetails(params?.value)}
            </div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        );
      }),

    new AGridColDef("updatedBy", "UPDATED BY")
      .columnAlign("center")
      .setFlex(0.3)
      .renderCellComponent((params) =>
        !params?.row.isEligibleForScan ? (
          <Tooltip title={params?.value}>
            <div className="ellipsis-text-container">{params?.value}</div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      ),

    new AGridColDef("consentStatus", "")
      .columnAlign("center")
      .setFlex(0.3)
      .renderCellComponent((params) => (
        <div
          style={{
            color:
              params.value === "Pending"
                ? "#705010"
                : params.value === "Issued"
                ? "#166534"
                : "#ea580c",
            background:
              params.value === "Pending"
                ? "#FFEDC8"
                : params.value === "Issued"
                ? "#dcfce7"
                : "#fff7ed",
          }}
          className="px-2 py-1 text-xs text-bold rounded-lg"
        >
          {params.value}
        </div>
      )),
  ];

  const nextButtonHandler = (pageNum, updatedPageSize) => {
    if (pageSize !== updatedPageSize) {
      setPageSize(updatedPageSize);
      setCurrentPage(0);
    } else setCurrentPage(pageNum);
  };

  const saveConsentStatus = async (scannedRfids) => {
    setIsLoading(true);
    const payload = {
      // materialId: filters.materialId.map((mat) => mat.value),
      request: scannedRfids.map(({ psid, applicationId, materialId }) => ({
        psid,
        applicationId,
        materialId,
      })),
    };

    const response = await saveRfidPsid(payload);
    if (response.code === 200) {
      successToast(response.data);
      searchStudentsForMaterials({});
      setIsLoading(false);
      setIsScanDialogOpen(false);
    }
  };

  const searchInputHandler = (value = userSearchInput) => {
    const updatedFilters = {
      ...filters,
      searchBy: value ? selected : "",
      searchByValue: value,
    };
    setFilters(updatedFilters);
  };

  const onKeyDownHandler = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      searchInputHandler();
    }
  };

  const handleOnUserInput = (value) => {
    setUserSearchInput(value);
    if (value === "" && value !== filters.searchByValue)
      searchInputHandler(value);
  };

  const downloadCsv = async () => {
    setIsLoading(true);

    const response = await downloadConsentCsv(filters);
    setIsLoading(false);
  };

  return (
    <>
      <Card className="mx-4 mb-4 rounded-3 flex-grow-1">
        <CardBody className="p-3">
          {isFilterApplied(filters) > 4 ? (
            <div className="d-flex align-items-center w-100 mb-3">
              <h2>{filters.batch?.label}</h2>

              <div className="ml-auto d-flex align-items-center">
                <AInput
                  placeholder="Search"
                  value={userSearchInput}
                  disabled={isLoading}
                  handler={handleOnUserInput}
                  onKeyDown={onKeyDownHandler}
                  searchIconClickHandler={() => {
                    searchInputHandler();
                  }}
                  crossIcon={false}
                  searchIcon={true}
                  style={{ width: "300px" }}
                  customSearchIconStyle={{ left: "5px" }}
                  rightCustomIconStyles={{
                    fontSize: "12px",
                    position: "absolute",
                    bottom: "7px",
                    right: "117px",
                    margin: "auto",
                  }}
                  rightCustomIcon={
                    <select
                      value={selected}
                      disabled={isLoading}
                      onChange={(e) => setSelected(e.target.value)}
                      style={{
                        position: "absolute",
                        bottom: "0",
                        margin: "auto 0",
                        background: "#FFF6E3",
                        color: "#A17217",
                        border: "none",
                      }}
                    >
                      {SEARCH_BY.map(({ key, value }) => (
                        <option value={key} key={key}>
                          {value}
                        </option>
                      ))}
                    </select>
                  }
                />

                <AButton onClick={downloadCsv} className="ml-3">
                  <MdOutlineSimCardDownload />
                  Download CSV
                </AButton>
              </div>
            </div>
          ) : (
            <></>
          )}

          <div style={{ height: "80vh" }}>
            {/* Scan RFID button */}
            <AButton
              size="xs"
              onClick={() => {
                if (totalRows) setIsScanDialogOpen(true);
                else failureToast(DISABLE_SCAN_MSG);
              }}
              style={{
                ...SCAN_BTN_STYLES,
                top: isFilterApplied(filters) > 4 ? "75px" : "21px",
              }}
            >
              Scan All
            </AButton>

            <ADataGrid
              removeWrapperContainer
              rows={rowData || []}
              columns={columns}
              rowId={(row) => `${row.applicationId}${row.materialId}`}
              rowHeight={50}
              loading={isLoading}
              rowCount={totalRows}
              nextButtonHandler={nextButtonHandler}
              currentPage={currentPage}
              checkboxSelection={ADMIN_ROLE_TYPES.includes(
                permissions.roleType
              )}
              isRowSelectable={(param) => param.row.isReversible}
              selectionModel={selectionModel}
              onSelectionModelChange={(newSelectionModel) => {
                setSelectionModel(newSelectionModel);
              }}
              hideFooterSelectedRowCount={true}
              disableSelectionOnClick
              pinLastColumn
              paginationModel={{
                page: currentPage,
                pageSize: pageSize,
              }}
            />
          </div>
        </CardBody>
      </Card>

      {isScanDialogOpen && (
        <ScanRfid
          isLoading={isLoading}
          open={isScanDialogOpen}
          closeDialog={() => setIsScanDialogOpen(false)}
          rowData={rowData}
          saveConsentStatus={saveConsentStatus}
          scannedRows={scannedRows}
          totalFetchedRows={Math.min(pageSize, totalRows)}
        />
      )}
    </>
  );
};

export default MaterialDistributionTable;
